import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import { getToken } from "@/api/auth.js"

const whiteList = ['/personal'] // 需要登陆的页面
// import VConsole from 'Vconsole';
// const vConsole = new VConsole()
// Storage.set('token', '5e07ef631b90b0ef97f05e2c35aecf40ac54f9fe')

router.beforeEach(async (to, from, next) => {
    if (getToken()) {
        if (!store.state.isInit) {
            store.state.isInit = true
            await store.dispatch('getInfo')
        }
        next()
    } else if (!getToken()) {
        if (whiteList.indexOf(to.path) != -1) {
            next({
                path: '/index',
                query: {}
            })
            return false
        }
        next()
        // console.log(routerOne)
        // if (whiteList.indexOf(routerOne) < 0) {
        // } else {
        //     next({
        //         path: '/index',
        //         query: {}
        //     })
        // }
    }

})